export enum TaskCalendarStatus {
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export type CalendarMode = "executions" | "standalone-alarms";

export type CalendarViewMode = "schedule" | "gantt";

export interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  extendedProps: {
    status: TaskCalendarStatus;
    /** Assigned user's name; only task executions have one. */
    assignee?: string;
  };
}

export interface DateRange {
  start: string;
  end: string;
}

export interface TaskCalendarProps {
  onBackClick?: () => void;
  mode?: CalendarMode;
}

/** @deprecated Use TaskCalendarStatus */
export { TaskCalendarStatus as Statuses };
